import { render, staticRenderFns } from "./MesaNewReservas.vue?vue&type=template&id=5a215d7b&scoped=true"
import script from "./MesaNewReservas.vue?vue&type=script&lang=js"
export * from "./MesaNewReservas.vue?vue&type=script&lang=js"
import style0 from "./MesaNewReservas.vue?vue&type=style&index=0&id=5a215d7b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a215d7b",
  null
  
)

export default component.exports